import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'home',
    component: _ => import('@/views/index/index.vue')
},{
    path: '/upload',
    name: 'upload',
    component: _ => import('@/views/upload/index.vue')
},{
    path: '/preview',
    name: 'preview',
    component: _ => import('@/views/preview/index.vue')
},{
    path: '/history',
    name: 'history',
    component: _ => import('@/views/history/index.vue')
},{
    path: '/regulation',
    name: 'regulation',
    component: _ => import('@/views/regulation/index.vue')
}]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
